import {Injectable} from '@angular/core';
import {BuilderStepsEnum} from "../builder-tour.enum";
import {combineLatest} from "rxjs/internal/observable/combineLatest";
import {filter, map} from "rxjs/operators";
import {
  BuilderGeneratedPageSectionI,
  PageMetaI,
  SecondaryPageReqI,
  SecondaryPageWithSectionsI
} from "../builder-v2.interface";
import {BuilderSectionsInteractionService} from "../builder-sections-interaction.service";
import {CommonBuilderDataService} from "./common-builder-data.service";
import {BuilderV2Service} from "../builder-v2.service";
import {DbResponse} from "../../shared/interceptors/db-response";

@Injectable({
  providedIn: 'root'
})
export class SecondaryPagesService {
  pageMeta;

  constructor(private _builderInteractionsService: BuilderSectionsInteractionService,
              private _builderService: BuilderV2Service,
              private _commonDataService: CommonBuilderDataService) {
  }
   getSecondaryPages() {
    const pagesRequests: DbResponse[] = this.pageMeta.map(page => this._getPage(page));
    combineLatest(pagesRequests).pipe(
      filter(value => !!value?.every(resp => !!resp?.data)),
      map(value => value.map((resp, index) => {
        this.pageMeta[index].page_type = resp.data.page_type;
        return {
          page: this.pageMeta[index],
          sections: this._setEmptyPagesWithHeaderAndFooter(resp.data.page_outline.sections)
        };
      }))
    ).subscribe(value => {
      this._setPagesWithSections(value);
    });
  }

  private _getPage(page) {
    const data = this._getPagesRequestData(page);
    const {domainId, uniqueId} = this._commonDataService;
    this._builderInteractionsService.secondaryPageLoading.next(true);
    return this._builderService.getSecondaryPage(data, domainId, uniqueId);
  }

  private _getPagesRequestData(page: PageMetaI): SecondaryPageReqI {
    const {business_type, business_name, business_description} = this._builderInteractionsService.siteInfo.value;
    const sections = this._builderInteractionsService.removeFormControls(this._builderInteractionsService.pageSections
      .filter(section => section.section_title || section.section_description)
      .map(({loading, is_tempo, ...section}, index) => {
        return {...section, index};
      }));

    return {
      business_type,
      business_name,
      business_description,
      website_type: this._commonDataService.websiteType,
      ecom_data: this._builderInteractionsService.updateProductCategories.value,
      page_description: page.description,
      page_index: page.index,
      page_title: page.title,
      page_type: page.page_type,
      slug: page.slug,
      id: page.id,
      homepage_outline: {sections}
    };
  }

  private _setPagesWithSections(value: SecondaryPageWithSectionsI[]) {
    this._builderInteractionsService.secondaryPages.next([...value]);
    setTimeout(() => {
      this._builderInteractionsService.secondaryPagesLoaded.next(true);
    }, 3000);
  }

  private _setEmptyPagesWithHeaderAndFooter(sections: BuilderGeneratedPageSectionI[]) {
    if (!sections.length) {
      sections = [
        {
          section_title: 'Header',
          section_description: 'header',
          section_type: 'header'
        },
        {
          section_title: 'Footer',
          section_description: 'footer',
          section_type: 'footer'
        }
      ];
    }
    return sections;
  }
}
